import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { filtered } from '../features/jobs/jobSlice';

const Sidebar = () => {
  const dispatch = useDispatch();
  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <button
              className="main-menu menu-active"
              id="lws-alljobs-menu"
              onClick={() => dispatch(filtered(''))}
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </button>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <button
                  className="sub-menu"
                  id="lws-internship-menu"
                  onClick={() => dispatch(filtered('Internship'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>{' '}
                  Internship
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  id="lws-fulltime-menu"
                  onClick={() => dispatch(filtered('Full Time'))}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i> Full Time
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  id="lws-remote-menu"
                  onClick={() => dispatch(filtered('Remote'))}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i> Remote
                </button>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/add" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i>
              <span> Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
